import {
  AmplifyGet,
  AmplifyPost,
} from '@sunrun/sales-experience-shared/amplify-api-wrapper';
import { logger } from './logger';

type TimeAttestationPromptResponseOption = {
  id: string;
  descriptor: string;
  order: string;
  requiresComment: boolean;
};

type TimeAttestationPrompt = {
  id: string;
  descriptor: string;
  order: string;
  blocking: boolean;
  required: boolean;
  requiresComment: boolean;
  responses: TimeAttestationPromptResponseOption[];
};

type TimeAttestationPromptsResponse = {
  total: number;
  data: TimeAttestationPrompt[];
};

type WorkdayAttestation = {
  promptId: string;
  responseId: string;
  comment?: string;
};

type TimeClockEventParams = {
  eventType: string;
  dateTime: string;
  timeZone: string;
};

type CreateTimeClockEventRequest = TimeClockEventParams & {
  timeEntryCode?: string;
  attestations?: WorkdayAttestation[];
};

type WorkdayReference = {
  id: string;
  descriptor: string;
};

type TimeClockEventHistoryItem = {
  id: string;
  descriptor: string;
  dateTime: string;
  reference_ID: string;
  eventType: WorkdayReference;
  worker: WorkdayReference;
  timeZone: WorkdayReference;
  timeEntryCode?: WorkdayReference;
  workerTimeAttestations?: (WorkdayReference & { order?: string })[];
};

type TimeClockEventsHistoryResponse = {
  total: number;
  data: TimeClockEventHistoryItem[];
};

type TimeClockEventsHistoryParams = {
  fromDate: string;
  toDate: string;
  limit?: string;
  offset?: string;
};

const API_NAME = 'SalesExpDashboardApi';

const getTimeAttestationPrompts = (
  hybridToken: string,
  params: TimeClockEventParams,
): Promise<TimeAttestationPromptsResponse> =>
  AmplifyGet<TimeAttestationPromptsResponse>(
    'Get Time Attestation Prompts',
    API_NAME,
    '/getTimeAttestationPrompts',
    {
      headers: {
        Authorization: `Bearer ${hybridToken}`,
      },
      queryStringParameters: params,
    },
    logger,
    {
      expectedErrorCodes: [401, 403],
    },
  );

const createTimeClockEvent = (
  hybridToken: string,
  body: CreateTimeClockEventRequest,
): Promise<unknown> =>
  AmplifyPost<unknown>(
    'Create Time Clock Event',
    API_NAME,
    '/createTimeClockEvent',
    {
      headers: {
        Authorization: `Bearer ${hybridToken}`,
      },
      body,
    },
    logger,
    {
      expectedErrorCodes: [401, 403],
    },
  );

const getTimeClockEventsHistory = (
  hybridToken: string,
  params: TimeClockEventsHistoryParams,
): Promise<TimeClockEventsHistoryResponse> =>
  AmplifyGet<TimeClockEventsHistoryResponse>(
    'Get Time Clock Events History',
    API_NAME,
    '/getTimeClockEventsHistory',
    {
      headers: {
        Authorization: `Bearer ${hybridToken}`,
      },
      queryStringParameters: params,
    },
    logger,
    {
      expectedErrorCodes: [401, 403],
    },
  );

export {
  getTimeAttestationPrompts,
  createTimeClockEvent,
  getTimeClockEventsHistory,
};
export type {
  TimeAttestationPromptResponseOption,
  TimeAttestationPrompt,
  TimeAttestationPromptsResponse,
  WorkdayAttestation,
  TimeClockEventParams,
  CreateTimeClockEventRequest,
  WorkdayReference,
  TimeClockEventHistoryItem,
  TimeClockEventsHistoryResponse,
  TimeClockEventsHistoryParams,
};
